// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"51":"652afb0e","585":"b91ea83e","818":"8d77f8d4","966":"28ab9c9b"}[chunkId] + ".chunk.js";
};